<script setup lang="ts">
import { computed, useSlots } from "vue";
import { breakpointsBootstrapV5, useBreakpoints } from "@vueuse/core";
import { isNullish } from "@tinyurldev/tu-ui-vue";

interface Props {
  title?: string
}

withDefaults(defineProps<Props>(), {
  title: "Organization Settings",
});

const slots = useSlots();
const breakpoints = useBreakpoints(breakpointsBootstrapV5);

const isSlotEmpty = computed(() => isNullish(slots.default));
const isMobileView = breakpoints.smallerOrEqual("xl");
</script>

<template>
  <div
    class="settings-top-bar"
    :class="{
      'settings-top-bar--mobile': isMobileView,
      'settings-top-bar--without-content': isSlotEmpty,
    }"
  >
    <h3 class="settings-top-bar__title _title">
      {{ title }}
    </h3>
    <div
      v-if="!isSlotEmpty"
      class="settings-top-bar__content _content"
    >
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/typography.scss" as typography;
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;

.settings-top-bar {
  $self: &;

  display: flex;
  align-items: center;
  justify-content: space-between;

  &__title {
    margin: 0;

    font-size: typography.$h3-font-size;
    line-height: typography.$h3-line-height;
    font-weight: typography.$font-weight-bold;
  }

  &__content:empty {
    display: none;
  }

  &--mobile {
    align-items: flex-start;
    flex-flow: column;
    gap: spacing.$m;

    #{ $self }__title,
    #{ $self }__content {
      width: 100%;
    }
  }
}
</style>
